import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from './auth.guard';
import { LoginServico } from './servicos/login.servico';
import { UtilServico } from './servicos/util.servico';
import { AppComponent } from './app.component';
import { InicialComponent } from './inicial/inicial.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import { LayoutInicialComponent } from './layout/layout-inicial/layout-inicial.component';
import { MatButtonModule, MatCheckboxModule, MatSelectModule, MatInputModule, MatMenuModule, MatIconModule, MatListModule, MatDatepickerModule, MatNativeDateModule, MatTabsModule, MatRadioModule, MAT_DATE_LOCALE } from '@angular/material';
import { CoolDirective } from './cool.directive';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMaskModule } from 'ngx-mask';
import { CurrencyMaskModule } from "ngx-currency-mask";
import { NgBootstrapFormValidationModule } from 'ng-bootstrap-form-validation';
import { MatTab } from '@angular/material/tabs/typings/tab';
import { UtilDadosLogado } from './servicos/util.logado';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LoginComponent } from './login/login.component';
import { HttpClientModule } from '@angular/common/http'
import { GovBrServico } from './servicos/govbr.servico';
import { EsqueciSenhaComponent } from './esqueci-senha/esqueci-senha.component';
import { FeriasComponent } from './inicial/ferias/ferias.component';
import { MatDialogModule } from '@angular/material/dialog';
registerLocaleData(localePt, 'pt-BR');

@NgModule({
  exports: [
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatInputModule,
    MatMenuModule,
    MatIconModule,
    MatListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatRadioModule
  ],
})
export class MaterialModule { }

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    InicialComponent,
    EsqueciSenhaComponent,
    LayoutInicialComponent,
    CoolDirective,
    FeriasComponent,
  ],
  imports: [
    HttpModule,
    HttpClientModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgxPaginationModule,
    NgxMaskModule.forRoot(),
    CurrencyMaskModule,
    NgBootstrapFormValidationModule.forRoot(),
    PdfViewerModule,
    MatDatepickerModule,
    MatDialogModule,
  ],
  providers: [
    AuthGuard,
    LoginServico,
    UtilDadosLogado,
    UtilServico,
    GovBrServico,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
  ],
  entryComponents: [
    FeriasComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
